export default "__VITE_ASSET__DLvJeuUB__"